module.exports = __webpack_public_path__ + "assets/guide.e7db8809.svg";